<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {TaskAction} from "@/modules/redactor/models/worker/tasks/TaskAction";


export default {
  name: "r-task-action",
  props: {
    model: VueTypes.instanceOf(TaskAction),
    label: VueTypes.string.def("Action:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return TaskAction.getValues();
    }
  }
}
</script>